(function () {
  function fixAccountLink() {
    document.querySelectorAll('a.header--account[target="_blank"]').forEach(a => {
      a.removeAttribute('target');
    });
  }

  // 初回
  document.addEventListener('DOMContentLoaded', fixAccountLink);

  // 後から付与されるケースにも対応
  new MutationObserver(fixAccountLink).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['target']
  });
})();